import { c as _c } from "react/compiler-runtime";
import { getFunnelStepUrl } from 'modules/funnels/funnel/utils/get-funnel-step-url';
import { ProductNameTagType } from 'modules/payment/transactions/components/transaction-payment-tooltip/product-name-tag';
import { ValueWithProductNameTag } from 'modules/payment/transactions/components/transaction-payment-tooltip/value-with-product-name-tag';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { PaymentItemInterface } from 'shared/types/payment-interface';
import { PricePlanTooltip } from 'shared/components/tooltip/price-plan-tooltip';
import { getProductPriceAmount } from '../../utils/product-transactions-utils';
import useUser from 'shared/hooks/use-user';
interface PaymentTooltipProps {
  paymentItem: PaymentItemInterface;
}
const TransactionPaymentTooltip = t0 => {
  const $ = _c(23);
  const {
    paymentItem
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const pricePlan = paymentItem.orderItem.pricePlan;
  const productOrderItem = paymentItem.orderItem.productOrderItem;
  const quantity = productOrderItem?.quantity ?? 1;
  let t1;
  if ($[0] !== pricePlan || $[1] !== productOrderItem || $[2] !== t) {
    t1 = !pricePlan ? <ValueWithProductNameTag value={productOrderItem && productOrderItem.product.name} type={ProductNameTagType.PHYSICAL_PRODUCT} t={t} /> : pricePlan.innerName;
    $[0] = pricePlan;
    $[1] = productOrderItem;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const value = t1;
  const t2 = user?.dashboardLocale;
  let t3;
  if ($[4] !== productOrderItem || $[5] !== quantity || $[6] !== t2) {
    t3 = getProductPriceAmount(quantity, productOrderItem, t2);
    $[4] = productOrderItem;
    $[5] = quantity;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== productOrderItem || $[9] !== t) {
    t4 = productOrderItem?.productVariant && <p className="text-start"><span className="text-text-primary font-bold">{t("dashboard.price_plan.products_variant.title")}:{" "}</span>{productOrderItem.productVariant.productOptionValues?.map(_temp).join(" / ")}</p>;
    $[8] = productOrderItem;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== paymentItem.orderItem.offer.funnelStep || $[12] !== paymentItem.orderItem.offer.removedAt || $[13] !== paymentItem.orderItem.pricePlan?.removedAt || $[14] !== value) {
    t5 = paymentItem.orderItem.offer.removedAt === null && paymentItem.orderItem.offer.funnelStep && paymentItem.orderItem.pricePlan?.removedAt === null ? <LinkWithoutPrefetch className="primary-link w-full" href={getFunnelStepUrl(paymentItem.orderItem.offer.funnelStep.funnel.id, paymentItem.orderItem.offer.funnelStep.id)}>{value}</LinkWithoutPrefetch> : value;
    $[11] = paymentItem.orderItem.offer.funnelStep;
    $[12] = paymentItem.orderItem.offer.removedAt;
    $[13] = paymentItem.orderItem.pricePlan?.removedAt;
    $[14] = value;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <div className="whitespace-normal">{t5}</div>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== pricePlan || $[19] !== t3 || $[20] !== t4 || $[21] !== t6) {
    t7 = <PricePlanTooltip pricePlan={pricePlan} productPriceAmount={t3} customRow={t4}>{t6}</PricePlanTooltip>;
    $[18] = pricePlan;
    $[19] = t3;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default TransactionPaymentTooltip;
function _temp(e) {
  return e.value;
}